export default "__VITE_ASSET__3TqkcxWV__"